/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_sorry_this_page_is_not_working: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Sorry, this page is not working.`,
    es: `Lo sentimos, esta página no está funcionando.`,
  };
  return phrases[locale] || phrases.en || `playlist description`;
};
